var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoKaiperClearspace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 553.43 165.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .logo_kaiper_clearspace-1, .logo_kaiper_clearspace-2 {\n        fill: none;\n      }\n\n      .logo_kaiper_clearspace-3 {\n        clip-path: url(#clippath-1);\n      }\n\n      .logo_kaiper_clearspace-2 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .logo_kaiper_clearspace-4 {\n        clip-path: url(#clippath-3);\n      }\n\n      .logo_kaiper_clearspace-5 {\n        clip-path: url(#clippath-2);\n      }\n\n      .logo_kaiper_clearspace-6 {\n        opacity: .05;\n      }\n\n      .logo_kaiper_clearspace-7 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_clearspace-1",
    x: 24.06,
    y: 14.32,
    width: 34.27,
    height: 34.27
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_clearspace-1",
    x: 24.06,
    y: 117.14,
    width: 34.27,
    height: 34.27
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_clearspace-1",
    x: 495.45,
    y: 14.32,
    width: 34.27,
    height: 34.27
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_clearspace-1",
    x: 495.45,
    y: 117.14,
    width: 34.27,
    height: 34.27
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "logo_kaiper_clearspace-2",
    points: "536.57 117.08 539.52 117.08 539.52 48.65 536.57 48.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "544.29 82.23 544.32 82.23 545.31 80.63 545.88 80.63 544.67 82.56 545.88 84.5 545.31 84.5 544.32 82.93 544.29 82.93 543.3 84.5 542.73 84.5 543.98 82.56 542.73 80.63 543.31 80.63 544.29 82.23"
  }), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_clearspace-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_clearspace-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.06,
    y: 14.32,
    width: 34.27,
    height: 34.27
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_clearspace-2",
    x: 24.06,
    y: 14.32,
    width: 34.27,
    height: 34.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.05,31.36c0-1.26.5-1.99,1.35-1.99s1.35.73,1.35,1.99-.5,1.99-1.35,1.99-1.35-.72-1.35-1.99ZM38.29,31.36c0-1-.33-1.57-.88-1.57s-.89.57-.89,1.57.33,1.56.89,1.56.88-.56.88-1.56ZM39.18,32.99c0-.19.16-.34.34-.34s.34.16.34.34-.16.35-.34.35-.35-.16-.34-.35ZM40.43,32.33h.47c.04.35.37.61.79.61.5,0,.87-.37.87-.86s-.38-.87-.9-.88c-.33,0-.58.1-.72.35h-.47l.27-2.12h2.1v.43h-1.7l-.14,1.14h.04c.17-.13.43-.22.71-.22.74,0,1.29.55,1.29,1.3s-.57,1.29-1.34,1.29c-.7,0-1.23-.43-1.26-1.03ZM44.91,31.03h.03l.99-1.6h.57l-1.22,1.94,1.22,1.94h-.57l-.99-1.57h-.03l-.99,1.57h-.57l1.25-1.94-1.25-1.94h.57l.99,1.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_clearspace-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_clearspace-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.06,
    y: 117.14,
    width: 34.27,
    height: 34.27
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_clearspace-2",
    x: 24.06,
    y: 117.14,
    width: 34.27,
    height: 34.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.05,134.18c0-1.26.5-1.99,1.35-1.99s1.35.73,1.35,1.99-.5,1.99-1.35,1.99-1.35-.72-1.35-1.99ZM38.29,134.18c0-1-.33-1.57-.88-1.57s-.89.57-.89,1.57.33,1.56.89,1.56.88-.56.88-1.56ZM39.18,135.8c0-.19.16-.34.34-.34s.34.16.34.34-.16.35-.34.35-.35-.16-.34-.35ZM40.43,135.14h.47c.04.35.37.61.79.61.5,0,.87-.37.87-.86s-.38-.87-.9-.88c-.33,0-.58.1-.72.35h-.47l.27-2.12h2.1v.43h-1.7l-.14,1.14h.04c.17-.13.43-.22.71-.22.74,0,1.29.55,1.29,1.3s-.57,1.29-1.34,1.29c-.7,0-1.23-.43-1.26-1.03ZM44.91,133.84h.03l.99-1.6h.57l-1.22,1.94,1.22,1.94h-.57l-.99-1.57h-.03l-.99,1.57h-.57l1.25-1.94-1.25-1.94h.57l.99,1.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_clearspace-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_clearspace-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.45,
    y: 14.32,
    width: 34.27,
    height: 34.27
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_clearspace-2",
    x: 495.45,
    y: 14.32,
    width: 34.27,
    height: 34.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.45,31.36c0-1.26.5-1.99,1.35-1.99s1.35.73,1.35,1.99-.5,1.99-1.35,1.99-1.35-.72-1.35-1.99ZM509.69,31.36c0-1-.33-1.57-.88-1.57s-.89.57-.89,1.57.33,1.56.89,1.56.88-.56.88-1.56ZM510.57,32.99c0-.19.16-.34.34-.34s.34.16.34.34-.16.35-.34.35-.35-.16-.34-.35ZM511.82,32.33h.47c.04.35.37.61.79.61.5,0,.87-.37.87-.86s-.38-.87-.9-.88c-.33,0-.58.1-.72.35h-.47l.27-2.12h2.1v.43h-1.7l-.14,1.14h.04c.17-.13.43-.22.71-.22.74,0,1.29.55,1.29,1.3s-.57,1.29-1.34,1.29c-.7,0-1.23-.43-1.26-1.03ZM516.3,31.03h.03l.99-1.6h.57l-1.22,1.94,1.22,1.94h-.57l-.99-1.57h-.03l-.99,1.57h-.57l1.25-1.94-1.25-1.94h.57l.99,1.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_clearspace-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo_kaiper_clearspace-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.45,
    y: 117.14,
    width: 34.27,
    height: 34.27
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_clearspace-2",
    x: 495.45,
    y: 117.14,
    width: 34.27,
    height: 34.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.45,134.18c0-1.26.5-1.99,1.35-1.99s1.35.73,1.35,1.99-.5,1.99-1.35,1.99-1.35-.72-1.35-1.99ZM509.69,134.18c0-1-.33-1.57-.88-1.57s-.89.57-.89,1.57.33,1.56.89,1.56.88-.56.88-1.56ZM510.57,135.8c0-.19.16-.34.34-.34s.34.16.34.34-.16.35-.34.35-.35-.16-.34-.35ZM511.82,135.14h.47c.04.35.37.61.79.61.5,0,.87-.37.87-.86s-.38-.87-.9-.88c-.33,0-.58.1-.72.35h-.47l.27-2.12h2.1v.43h-1.7l-.14,1.14h.04c.17-.13.43-.22.71-.22.74,0,1.29.55,1.29,1.3s-.57,1.29-1.34,1.29c-.7,0-1.23-.43-1.26-1.03ZM516.3,133.84h.03l.99-1.6h.57l-1.22,1.94,1.22,1.94h-.57l-.99-1.57h-.03l-.99,1.57h-.57l1.25-1.94-1.25-1.94h.57l.99,1.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.63,
    y: 75.88,
    width: 37.83,
    height: 13.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.24,48.6h-47.4v68.54h17.22v-21.7h30.18c12.94,0,23.42-10.49,23.42-23.42s-10.49-23.42-23.42-23.42M307.52,80.93h-27.47v-17.83h27.47c4.92,0,8.92,3.99,8.92,8.91s-3.99,8.92-8.92,8.92"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.64,
    y: 48.59,
    width: 17.22,
    height: 68.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.55,48.59h-27.89l-29.32,68.54h19.06l5.73-14.17h36.95l5.73,14.17h19.06l-29.32-68.54ZM165.71,89.17l10.69-26.42h4.41l10.68,26.42h-25.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.32,
    y: 48.59,
    width: 17.22,
    height: 68.54
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.82 87.46 108.53 117.14 133.48 117.14 105.45 87.46 80.82 87.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.82 78.27 108.53 48.59 133.48 48.59 105.45 78.27 80.82 78.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.63,117.14h20.81l-18.24-25.76c9.39-2.4,16.33-10.91,16.33-21.05,0-12-9.73-21.73-21.73-21.73h-49.1v68.54h17.22v-25.08h18.17l16.52,25.08ZM439.94,63.1h28.65c4.27,0,7.73,3.46,7.73,7.73s-3.46,7.73-7.73,7.73h-28.65v-15.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.46 62.75 408.46 48.59 344.22 48.59 344.22 117.14 408.46 117.14 408.46 102.99 361.44 102.99 361.44 62.75 408.46 62.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_clearspace-2",
    x: 58.32,
    y: 48.59,
    width: 437.24,
    height: 68.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_clearspace-2",
    x: 24.06,
    y: 14.32,
    width: 505.66,
    height: 137.09
  })), /*#__PURE__*/React.createElement("rect", {
    className: "logo_kaiper_clearspace-1",
    width: 553.43,
    height: 165.73
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKaiperClearspace);
export default __webpack_public_path__ + "static/media/logo_kaiper_clearspace.24bd40048df3a01110399bfbe0b4a017.svg";
export { ForwardRef as ReactComponent };